import {tns} from 'tiny-slider/src/tiny-slider';

export default (() => {


    $(document).ready(function() {
        $('.header-slider').each(function(){
            window.headerSlider = tns({
                container: $(this)[0],
                items: 1,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayButtonOutput: false,
                lazyload: false,
                speed: 1000,
                touch: true,
                controls: false,
                navPosition: 'bottom',
            });
        })

        if($('.header-slider .slide:nth-child(2)').children('.video-wrapper').length) {
            var videoWrapper = $('.header-slider .slide:nth-child(2)').children('.video-wrapper'),
                video = videoWrapper.children('video')[0];
                window.headerSlider.pause();

                var interval = setInterval(function() {
                    if(video.duration) {
                        clearTimeout(interval);                        

                        setTimeout(function() {
                            window.headerSlider.play();
                        }, Math.round(video.duration * 1000) - 7000)
                    }
                }, 500);
        }

        $('.header-slider-outer .tns-nav').wrap('<div class="nav-holder container-fluid"></div>');

        $('#toggle-header-widget').click(function() {
            if($(window).width() < 991) {
                $(this).siblings('form').slideToggle();
            }
        })
    })
});



// WEBPACK FOOTER //
// ./scripts/components/header-slider.js